import { render, staticRenderFns } from "./mould.vue?vue&type=template&id=b5154fd4&scoped=true&"
import script from "./mould.vue?vue&type=script&lang=js&"
export * from "./mould.vue?vue&type=script&lang=js&"
import style0 from "./mould.vue?vue&type=style&index=0&id=b5154fd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5154fd4",
  null
  
)

export default component.exports